import { Dialog } from 'quasar';
import InitPortfolioDialog from 'src/pages/mockup/InitPortfolioDialog.vue';

export function getFieldLabelBy (type) {
    switch (type) {
        case 'string':
            return 'Текст';
        case 'file':
            return 'Файл';
        case 'img':
            return 'Изображение';
        default:
            return 'что за тип';
    }
}

export function getFieldIconBy (type) {
    switch (type) {
        case 'string':
            return 'article';
        case 'file':
            return 'attach_file';
        case 'img':
            return 'image';
        default:
            return 'что за тип';
    }
}

export function decodeHTML (text) {
    if (!text) return '';
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
}

export function compareFunc (itemA, itemB) {
    if (+itemA.position > +itemB.position) {
        return 1;
    }
    if (+itemA.position < +itemB.position) {
        return -1;
    }
    return 0;
}

export function initPortfolioDialog () {
    return Dialog.create({
        component: InitPortfolioDialog,
    });
}

export function toDataUrl (url) {
    return new Promise((resolve) => {
        fetch(url)
            .then((res) => res.blob())
            .then((imgData) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.readAsDataURL(imgData);
            });
    });
}

export function clearJSONValue (value) {
    let result = value;
    result = result.replaceAll('"', '“');
    result = result.replaceAll('\'', '`');
    result = result.replaceAll(/[^a-zA-Zа-яёА-ЯЁ\d\\/ !,*)(@?.:;#№%&$_^+~<>`“\\-]/g, '');
    return result;
}
